import React from 'react'
import Feed from 'Pods/Profile/Dashboard/Feed/Feed'

function FeedPage() {
  return (
    <div className="container-fixed cgt-mt-20">
      <div className="row">
        <div className="col-12 col-xl-10 offset-xl-1">
          <Feed />
        </div>
      </div>
    </div>
  )
}

export default FeedPage
